import i18next from 'i18next';
import { notification } from 'antd';

export const showNoSelectedFieldsErrorNotification = () => {
  notification.error({
    message: i18next.t(
      'Task.Notification.TaskCantBeCreatedWithoutFields',
      "Task can't be created without fields",
    ),
    description: i18next.t(
      'Task.Notification.SelectAtLeast1TaskField',
      'Select at least 1 field on map by clicking on it.',
    ),
    placement: 'bottomRight',
  });
};

export const showCreateTaskSuccessNotification = () => {
  notification.success({
    message: i18next.t(
      'Task.Notification.Created',
      'Task created successfully',
    ),
    description: i18next.t(
      'Task.Notification.CreatedDescription',
      'You can find the task in the task list. You can modify it and record its execution in the task window.',
    ),
    placement: 'bottomRight',
  });
};

// Company notifications
export const showAcceptedCompanyShareNotification = (companyName: string) => {
  notification.success({
    message: i18next.t('Company.Notification.CompanyShareAccepted', {
      defaultValue: 'You accepted  “{{companyName}}” invitation',
      companyName: companyName,
    }),
    placement: 'bottomRight',
  });
};

export const showDeclinedCompanyShareNotification = (companyName: string) => {
  notification.warning({
    message: i18next.t('Company.Notification.CompanyShareRejected', {
      defaultValue: 'You rejected  “{{companyName}}” invitation',
      companyName: companyName,
    }),
    placement: 'bottomRight',
  });
};

export const showDeleteTaskSuccessNotification = () => {
  notification.success({
    message: i18next.t(
      'Task.EdtiTask.DeleteSuccess',
      'Task successfully deleted',
    ),
    placement: 'bottomRight',
  });
};

export const showArchiveCompanyGroupSuccessNotification = () => {
  notification.success({
    message: i18next.t(
      'Company.ArchiveCompanyGroupSuccess',
      'Company group successfully archived',
    ),
    placement: 'bottomRight',
  });
};

// Polygon notifications
export const showPolygonsUploadSuccessNotification = () => {
  notification.success({
    message: i18next.t('Field.Notification.FieldsAdded', 'New fields added'),
    placement: 'bottomRight',
  });
};

export const showSelectAtLeast1FieldWarningNotification = () => {
  notification.warn({
    message: i18next.t(
      'Field.Notification.NoSelectedNewFieldSubmitError',
      'Please select at least 1 field',
    ),
    placement: 'bottomRight',
  });
};

// Routes notifications

export const showAddRouteToTaskSuccessNotification = () => {
  notification.success({
    message: i18next.t(
      'Task.Notification.RoutesAdded',
      'Routes have been successfully assigned to task',
    ),
    placement: 'bottomRight',
  });
};
